import Link from '@components/common/Link/Link'
import Section from '@components/common/Section/Section'
import TrustedHtml from '@components/common/TrustedHtml/TrustedHtml'
import Media from '@components/ui/Media/Media'

import { findRichTextLink } from '@lib/findRichTextLink'
import { MediaWithCropsFragment } from '@lib/umbraco/generated/types.generated'
import { FC, useRef } from 'react'
import styles from './M453Images3Texts.module.scss'

export type M453Images3TextsProps = {
  image1?: MediaWithCropsFragment
  richText1?: string
  image2?: MediaWithCropsFragment
  richText2?: string
  image3?: MediaWithCropsFragment
  richText3?: string
  reversed?: boolean
}

const M453Images3Texts: FC<M453Images3TextsProps> = ({
  image1,
  richText1,
  image2,
  richText2,
  image3,
  richText3,
  reversed,
}) => {
  const container = useRef<HTMLDivElement>(null)
  const firstImageInnerContainer = useRef<HTMLDivElement>(null)
  const secondImageInnerContainer = useRef<HTMLDivElement>(null)
  const thirdImageInnerContainer = useRef<HTMLDivElement>(null)

  return (
    <Section className={styles.outerContainer}>
      <div className={styles.container} ref={container}>
        <div className={`${styles.grid} ${reversed && styles.reversed}`}>
          <div className={styles.richText1}>
            <TrustedHtml html={richText1} />
          </div>
          <Link
            link={findRichTextLink(richText1)}
            className={styles.firstImage}
          >
            <div
              className={styles.imageInnerContainer}
              ref={firstImageInnerContainer}
            >
              <Media mediaWithCrops={image1} className={styles.media} />
              {/* {image1?.alt && <p>{image1.alt}</p>} */}
            </div>
          </Link>
          <Link
            link={findRichTextLink(richText2)}
            className={styles.secondImage}
          >
            <div
              className={styles.imageInnerContainer}
              ref={secondImageInnerContainer}
            >
              <Media mediaWithCrops={image2} className={styles.media} />
              {/* {image2?.alt && <p>{image2.alt}</p>} */}
            </div>
          </Link>
          <div className={styles.richText2}>
            <TrustedHtml html={richText2} />
          </div>

          <Link
            link={findRichTextLink(richText3)}
            className={styles.thirdImage}
          >
            <div
              className={styles.imageInnerContainer}
              ref={thirdImageInnerContainer}
            >
              <Media mediaWithCrops={image3} className={styles.media} />
              {/* {image3?.alt && <p>{image3.alt}</p>} */}
            </div>
          </Link>
          <div className={styles.richText3}>
            <TrustedHtml html={richText3} />
          </div>
        </div>
      </div>
    </Section>
  )
}

export default M453Images3Texts
